import { FORM_FIELDS, FORM_FIELDS_NAMES } from './new-application-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { yesNoList } from '../application-view/company-info-inputs';
import { ILists } from '../../interfaces/merchant';

interface IBusinessModelInputs {
  t: any;
  lists: ILists;
  isRequired?: boolean;
}
export const BUSINESS_MODEL_INPUTS = ({ t, lists, isRequired }: IBusinessModelInputs): IFormInputProps[] => [
  // {
  //   key: FORM_FIELDS.INDUSTRY,
  //   fieldName: FORM_FIELDS.INDUSTRY,
  //   placeholder: t(FORM_FIELDS_NAMES.INDUSTRY),
  //   label: t(FORM_FIELDS_NAMES.INDUSTRY),
  //   inputType: InputType.Select,
  //   data: lists?.industries,
  //   cleanable: false,
  //   searchable: false,
  //   required: isRequired,
  //   autoComplete: 'off'
  // },
  {
    key: FORM_FIELDS.URL_NUMBER,
    fieldName: FORM_FIELDS.URL_NUMBER,
    placeholder: t(FORM_FIELDS_NAMES.URL_NUMBER_PLACEHOLDER),
    label: t(FORM_FIELDS_NAMES.URL_NUMBER),
    inputType: InputType.Select,
    data: lists.urlsRange,
    cleanable: false,
    searchable: false,
    required: isRequired,
    isLabelIcon: true,
    tooltipText: t(FORM_FIELDS_NAMES.URL_NUMBER_TOOLTIP),
    autoComplete: 'off'
  },
  // {
  //   key: FORM_FIELDS.INFO_AVAILABLE,
  //   fieldName: FORM_FIELDS.INFO_AVAILABLE,
  //   placeholder: t(FORM_FIELDS_NAMES.INFO_AVAILABLE),
  //   label: t(FORM_FIELDS_NAMES.INFO_AVAILABLE),
  //   inputType: InputType.Select,
  //   data: yesNoList,
  //   cleanable: false,
  //   searchable: false,
  //   required: isRequired,
  //   isLabelIcon: true,
  //   tooltipText: t(FORM_FIELDS_NAMES.INFO_AVAILABLE_TOOLTIP),
  //   autoComplete: 'off'
  // },
  {
    key: FORM_FIELDS.IS_REGULATED,
    fieldName: FORM_FIELDS.IS_REGULATED,
    // placeholder: t(FORM_FIELDS_NAMES.IS_REGULATED),
    label: t(FORM_FIELDS_NAMES.IS_REGULATED),
    inputType: InputType.Select,
    data: yesNoList,
    cleanable: false,
    searchable: false,
    required: isRequired,
    isLabelIcon: true,
    tooltipText: t(FORM_FIELDS_NAMES.IS_REGULATED_TOOLTIP),
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.IS_RELATED_TO_HEALTH,
    fieldName: FORM_FIELDS.IS_RELATED_TO_HEALTH,
    // placeholder: t(FORM_FIELDS_NAMES.IS_RELATED_TO_HEALTH),
    label: t(FORM_FIELDS_NAMES.IS_RELATED_TO_HEALTH),
    inputType: InputType.Select,
    data: yesNoList,
    cleanable: false,
    searchable: false,
    required: isRequired,
    isLabelIcon: true,
    tooltipText: t(FORM_FIELDS_NAMES.IS_RELATED_TO_HEALTH_TOOLTIP),
    autoComplete: 'off'
  }
];
